import {
  BaseSchedulerHighlightValue,
  createSchedulerFiltersStore,
  createSchedulerHighlightStore,
} from '@lp/core/store/scheduler';

export const useOMSSchedulerFiltersStore = createSchedulerFiltersStore();

type OMSSchedulerHighlightValue = BaseSchedulerHighlightValue;

export const useOMSSchedulerHighlightStore = createSchedulerHighlightStore<OMSSchedulerHighlightValue>();
